import { render, staticRenderFns } from "./ConsultationInfo.vue?vue&type=template&id=0c85355c&scoped=true"
import script from "./ConsultationInfo.vue?vue&type=script&lang=js"
export * from "./ConsultationInfo.vue?vue&type=script&lang=js"
import style0 from "./ConsultationInfo.vue?vue&type=style&index=0&id=0c85355c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85355c",
  null
  
)

export default component.exports